<template>
    <footer id="colophon" class="site-footer" role="contentinfo">
        <div id="footer-banner" class="cf menu-is-additional">
            <div id="horizontal-menu-wrap" class="is-additional logo">
                <div id="horizontal-menu-before" class="switch thm-left-left is-menu">
                    <div class="site-branding">
                        <h1 class="site-logo"><a href="/" rel="home"><img :src="logo" alt="logo"></a></h1>
                    </div>
                </div>
                <section id="footer-horizontal-menu" class="is-before">
                    <div>

                        <div class="footer-menu">
                            <ul id="menu-footer" class="menu">
                                <li id="menu-item-381" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-217 current_page_item menu-item-381"><a href="/">Home</a>
                                </li>
                                <li id="menu-item-382" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-382"><a href="/about/">About</a>
                                </li>
           <!--                      <li id="menu-item-383" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-383"><a href="/credits/">Credits</a>
           </li> -->
                                <li id="menu-item-384" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-384"><a href="/contact/">Contact</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </section>
            </div>
            <!-- EOF horizontal-menu-wrap -->
            <div id="designer">
                Copyright {{year}} | <a href="/">{{storeName}}</a>
            </div>
        </div>
    </footer>
</template>
<style scoped id='tesseract-footer-banner-inline-css' type='text/css'>
    #colophon {
        background-color: #ffffff;
        color: #000000
    }
    #colophon h1,
    #colophon h2,
    #colophon h3,
    #colophon h4,
    #colophon h5,
    #colophon h6 {
        color: #000000;
    }
    #colophon a {
        color: #000000;
    }
    #colophon a:hover {
        color: #089afc;
    }
    #horizontal-menu-before,
    #horizontal-menu-after {
        border-color: rgba(0, 0, 0, 0.25);
    }
    #footer-banner.footbar-active {
        border-color: rgba(0, 0, 0, 0.15);
    }
    ;
</style>
<script type="text/javascript">
    export
    default {
        props: ["logo", "year", "storeName"]
    }
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue